export const PATHS = {
  LANDING: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  CUSTOMERS: '/customers',
  ADD_CUSTOMER: '/customers/add',
  LEDGER: '/customers/:id/ledger',
  ADD_TRANSACTION: '/customers/:id/transaction',
  TRANSACTIONS: '/transactions',
  REPORTS: '/reports',
  PAYMENTS: '/payments',
  PRODUCTS: '/products',
  SETTINGS: '/settings',
  STAFF: '/staff',
  PRICING: '/pricing',
  BILLING: '/billing'
};
